import React, {useEffect, useMemo, useRef, useState} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import Icon, {icons} from './Icons'
import '../css/DriverAge.scss'
import { inputTypes } from '../const'

export default props => {
    const {
        driverType,
        style,
        forceClose,
        setActiveInput,
        inputType,
        onChange,
        textRegularDriver,
        textYoungDriver21,
        textYoungDriver23,
        DriverLeyend
    } = props


    const [isOpen, setIsOpen] = useState(false)
    const triggerRef = useRef(null)
    const optionRefs = useRef([])
    const listboxId = `driver-age-options-${inputType}`
    const options = useMemo(() => [
        {value: 1, label: textYoungDriver21},
        {value: 2, label: textYoungDriver23},
        {value: 3, label: textRegularDriver}
    ], [textRegularDriver, textYoungDriver21, textYoungDriver23])

    useEffect(() => {
        if(isOpen && forceClose) setIsOpen(false)
    }, [forceClose, isOpen])

    const handleClick = () => {
        setIsOpen(!isOpen)        
        setActiveInput(isOpen ? inputTypes.none : inputType)
    }

    useEffect(() => {
        if (!isOpen) return
        const selectedIndex = Math.max(0, options.findIndex(option => option.value === driverType))
        const option = optionRefs.current[selectedIndex]
        if (option) option.focus()
    }, [driverType, isOpen, options])

    const closeAndFocusTrigger = () => {
        setIsOpen(false)
        setActiveInput(inputTypes.none)
        setTimeout(() => triggerRef.current && triggerRef.current.focus(), 0)
    }

    const selectDriverType = value => {
        onChange(value)
        closeAndFocusTrigger()
    }

    const focusOption = index => {
        const boundedIndex = Math.max(0, Math.min(index, options.length - 1))
        const option = optionRefs.current[boundedIndex]
        if (option) option.focus()
    }

    const handleOptionKeyDown = (event, option, index) => {
        if (event.key === 'ArrowDown') {
            event.preventDefault()
            focusOption(index + 1)
        } else if (event.key === 'ArrowUp') {
            event.preventDefault()
            focusOption(index - 1)
        } else if (event.key === 'Home') {
            event.preventDefault()
            focusOption(0)
        } else if (event.key === 'End') {
            event.preventDefault()
            focusOption(options.length - 1)
        } else if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            selectDriverType(option.value)
        } else if (event.key === 'Escape') {
            event.preventDefault()
            closeAndFocusTrigger()
        }
    }


    return (
        <div className="driver-age-container" style={style}>
            <button
                type="button"
                className="selected-age"
                ref={triggerRef}
                aria-label={DriverLeyend}
                aria-haspopup="listbox"
                aria-expanded={isOpen}
                aria-controls={listboxId}
                onClick={handleClick}
                onKeyDown={event => {
                    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                        event.preventDefault()
                        if (!isOpen) handleClick()
                    } else if (event.key === 'Escape' && isOpen) {
                        event.preventDefault()
                        closeAndFocusTrigger()
                    }
                }}
            >
                <Icon icon={icons.driver} className='icon-input' />
                <span className='driver-age-value' >{driverType === 1 ? textYoungDriver21 : (driverType === 2 ? textYoungDriver23 : textRegularDriver) }</span>
                <FontAwesomeIcon icon='chevron-down' className='icon-input' />
            </button>
            
            {isOpen && 
             <div className="selection-ages" id={listboxId} role="listbox" aria-label={DriverLeyend}>
                 {options.map((option, index) => <div
                     key={option.value}
                     className={classNames('selecion-ages-item', driverType === option.value ? 'selected' : '')}
                     role="option"
                     aria-selected={driverType === option.value}
                     tabIndex={driverType === option.value ? 0 : -1}
                     ref={element => { optionRefs.current[index] = element }}
                     onClick={() => selectDriverType(option.value)}
                     onKeyDown={event => handleOptionKeyDown(event, option, index)}
                 >
                     {option.label}
                 </div>)}
             </div> 
            }
        </div>
    )
}
